import * as React from 'react';

import Grid from '@mui/material/Grid';


export default function Gallery({images}) {

  return (

    <div id="Galley">

      <Grid container spacing={0}>

        {images.map((element, index) => {
        
        return (
          <Grid item xs={12} md={12} lg={4} className='photogallery' >

            <img src={element} className='gallery' alt="gallery"/>

          </Grid>  
        )

        })}

      </Grid>

    </div>

  );
}
